import { ICompany } from './company'
import { IProfile } from './profile'
import { ISubscription } from './subscription'
import { IWorkspace } from './workspace'

export interface IUser {
  _id?: string
  firstName: string
  lastName: string
  email: string
  password: string
  isActive: boolean
  permissions: string[]
  roles: string[]
  createdAt: Date
  updatedAt: Date
  company?: ICompany | string | null
  linkedIn?: string
  jobRole?: string
  profile?: IProfile
  educationProvider?: unknown // TODO: add type if needed
  workspaces?: IWorkspace[]
  subscriptions?: ISubscription[]
}

export enum UserRole {
  SuperAdmin = 'superadmin',
  EducationProvider = 'educationprovider',
  User = 'user',
  Applicant = 'applicant',
  Employer = 'employer',
  TaxBenefitsProvider = 'taxbenefitsprovider',
}

export enum UserInclude {
  TaxBenefitProviders = 'taxBenefitProviders',
  Company = 'company',
  EducationProvider = 'educationProvider',
  Profile = 'profile',
  Workspaces = 'workspaces',
  Subscriptions = 'subscriptions',
}

export interface IUserCoursesRecommendations {
  // Add properties as needed
  recommendations?: unknown[]
}
